import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import LayersIcon from '@material-ui/icons/Layers';
import Menu from '@material-ui/core/Menu';
import Typography from '@material-ui/core/Typography';
import { Box, MenuItem } from '@material-ui/core';
import Checkbox from '../Checkbox/index';
import startCase from 'lodash/startCase';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const Layers = ({ handleChange, value, layerType = [] }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className={classes.layerBox}>
      <Box
        component={'div'}
        className={classes.iconWrapper}
        boxShadow={2}
        onClick={handleClick}
      >
        <Box component={'div'}>
          <LayersIcon className={classes.layerIcon} />
          {/* {'Switch Layers'} */}
        </Box>
      </Box>

      <Menu
        id="LayerBox"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        elevation={1}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        classes={{ paper: classes.layerTypes }}
      >
        {layerType.map((layer, index) => {
          return (
            <MenuItem key={index}>
              <Typography
                component="span"
                variant="body2"
                className={classes.inline}
                color="textPrimary"
              >
                <Checkbox
                  label={t(startCase(layer))}
                  value={value[layer]}
                  onChange={handleChange}
                  name={t(layer)}
                />
              </Typography>
            </MenuItem>
          );
        })}
      </Menu>
    </div>
  );
};

const useStyles = makeStyles(theme => ({
  iconWrapper: {
    backgroundColor: '#ffffff',
    height: '30px',
    padding: '5px',
    width: '50px',
    display: 'flex',
    justifyContent: 'center',
    cursor: 'pointer',
    '&:hover': {
      background: '#e0e1e1',
    },
  },
  layerBox: {
    position: 'absolute',
    zIndex: 10,
    top: '10px',
    left: '180px',
  },

  layerIcon: {
    width: 30,
    height: 30,
    color: theme.palette.primary.main,
  },

  layerTypes: {
    maxWidth: 200,
    backgroundColor: theme.palette.background.paper,
  },
  inline: {
    display: 'inline',
    color: theme.palette.text.primary,
  },
}));

Layers.propTypes = {
  handleChange: PropTypes.func,
  value: PropTypes.object,
  layerType: PropTypes.array,
};
export default Layers;
